/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type PopularSearchesSitemapLinksBlock_connectionLinks = {
    readonly edges: ReadonlyArray<{
        readonly node: {
            readonly text: string | null;
            readonly path: string | null;
            readonly " $fragmentRefs": FragmentRefs<"SeoLink_linkData">;
        };
    } | null> | null;
    readonly " $refType": "PopularSearchesSitemapLinksBlock_connectionLinks";
};
export type PopularSearchesSitemapLinksBlock_connectionLinks$data = PopularSearchesSitemapLinksBlock_connectionLinks;
export type PopularSearchesSitemapLinksBlock_connectionLinks$key = {
    readonly " $data"?: PopularSearchesSitemapLinksBlock_connectionLinks$data;
    readonly " $fragmentRefs": FragmentRefs<"PopularSearchesSitemapLinksBlock_connectionLinks">;
};



const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PopularSearchesSitemapLinksBlock_connectionLinks",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "PopularBuyPagesEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "LinkData",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "text",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "path",
              "storageKey": null
            },
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "SeoLink_linkData"
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "PopularBuyPagesConnection",
  "abstractKey": null
};
(node as any).hash = 'bc4c6ec73d3c2b0fac3be19d67b1f9ab';
export default node;
